// Tracks the boards this browser has opened, so the home page can show a
// list of recent boards. Without a backend there's no server-side concept
// of "my boards" — localStorage IS the recents list.

const STORAGE_KEY = 'frame-recent-boards';
const MAX_ENTRIES = 12;

export interface RecentBoard {
  id: string;
  lastOpened: number;
}

export function listRecentBoards(): RecentBoard[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((b): b is RecentBoard => !!b && typeof b.id === 'string' && typeof b.lastOpened === 'number')
      .sort((a, b) => b.lastOpened - a.lastOpened);
  } catch {
    return [];
  }
}

export function rememberRecentBoard(id: string): void {
  if (!id) return;
  try {
    const current = listRecentBoards().filter((b) => b.id !== id);
    const next: RecentBoard[] = [{ id, lastOpened: Date.now() }, ...current].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* quota / SSR */
  }
}

export function forgetRecentBoard(id: string): void {
  try {
    const next = listRecentBoards().filter((b) => b.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* quota / SSR */
  }
}
